import React from 'react';
import { TooltipProps } from 'recharts';
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';
import { styled } from '@mui/material/styles';
import { aggregatedParameters } from '../../../../measurements/utils';
import { useMeterDetailsContext } from '../../../context';
import { useChartFormat } from '../../hooks/use-chart-format';

const TooltipWrapper = styled('div')(() => ({
  backgroundColor: 'var(--color-element)',
  color: 'var(--color-type-primary)',
  border: '1px solid var(--color-type-primary)',
  padding: '4px 8px',
  borderRadius: 8,
  fontSize: 12,
}));

const TooltipLabel = styled('div')({
  fontWeight: 600,
  marginBottom: 4,
});

const TooltipEntry = styled('div')({
  marginBottom: 2,
});

const EntryName = styled('span')<{ color: string }>(({ color }) => ({
  color,
}));

const EntryValue = styled('span')({
  color: 'var(--color-type-primary)',
});

export const CustomTooltip: React.FC<TooltipProps<ValueType, NameType>> = ({ active, payload, label }) => {
  const { comparatorParam } = useMeterDetailsContext();
  const { getLabel } = useChartFormat();

  if (active && payload && payload.length) {
    const params = aggregatedParameters[comparatorParam];

    return (
      <TooltipWrapper>
        <TooltipLabel>{label}</TooltipLabel>
        {payload.map((entry, idx) => {
          const value = typeof entry.value === 'number' ? entry.value.toFixed(params.fixed) : entry.value;

          return (
            <TooltipEntry key={idx}>
              <EntryName color={entry.color as string}>{`${getLabel(entry.name as string)}: `}</EntryName>
              <EntryValue>{`${value} ${params.unit}`}</EntryValue>
            </TooltipEntry>
          );
        })}
      </TooltipWrapper>
    );
  }

  return null;
};
